import { tx } from "@/i18n/tx";
import { useMemo } from "react";
import { ATMOSPHERES, atmosphereForToday } from "@/data/homeAtmospheres";
import { ACCENTS } from "@/components/AtmosphereAccents";

export function DailyAtmosphere({ forced = null }) {
  const atm = useMemo(() => {
    if (forced) return forced;
    // Override per anteprima: ?atm=0|1|2 (o id). Altrimenti selezione per data locale.
    try {
      const q = new URLSearchParams(window.location.search).get("atm");
      if (q != null) {
        const byIdx = ATMOSPHERES[Number(q)];
        if (byIdx) return byIdx;
        const byId = ATMOSPHERES.find((a) => a.id === q);
        if (byId) return byId;
      }
    } catch { /* noop */ }
    return atmosphereForToday();
  }, [forced]);

  const bg = useMemo(() => `${atm.layers.join(", ")}, ${atm.base}`, [atm]);

  return (
    <section
      data-testid="daily-atmosphere"
      data-atmosphere={atm.id}
      className="daily-atmosphere px-6 pt-8 pb-7"
      style={{ background: bg }}
    >
      <div className="atm-accents">
        {atm.accents.map((key) => {
          const Accent = ACCENTS[key];
          return Accent ? <Accent key={key} /> : null;
        })}
      </div>

      <img
        src="/flame-emblem.webp"
        alt={tx("Fiamma dello Spirito")}
        className="atm-flame atm-flame-glow atm-flame-intro"
        draggable={false}
        onContextMenu={(e) => e.preventDefault()}
      />

      <div className="atm-invite mt-4">
        <p className="font-serif text-xl sm:text-2xl text-anima-ink leading-snug" data-testid="atm-phrase">
          {tx(atm.phrase)}
        </p>
        {atm.action && (
          <p className="text-sm text-anima-sagedeep mt-2" data-testid="atm-action">
            {tx(atm.action)}
          </p>
        )}
      </div>
    </section>
  );
}
